import React, { useState, useEffect } from "react";
import Formulario from "./components/Formulario";
import ListadoImagenes from "./components/ListadoImagenes";
import { TiArrowLeftThick, TiArrowRightThick } from "react-icons/ti";

function App() {
  const [search, setSearch] = useState("");
  const [imagenes, setImagenes] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);

  useEffect(() => {
    const consultarApi = async () => {
      if (search === "") return;

      const imagenesPorPagina = 24;
      const key = "32109239-124c94f65b7a035231d53b249";
      const url = `https://pixabay.com/api/?key=${key}&q=${search}&per_page=${imagenesPorPagina}&page=${paginaActual}`;

      const respuesta = await fetch(url);
      const resultado = await respuesta.json();
      setImagenes(resultado.hits);

      // Calcular el total de paginas
      const calcularTotalPaginas = Math.ceil(
        resultado.totalHits / imagenesPorPagina
      );

      setTotalPaginas(calcularTotalPaginas);

      // Mover la pantalla hacia arriba
      const jumbotron = document.querySelector(".jumbotron");
      jumbotron.scrollIntoView({ behavior: "smooth" });
    };
    consultarApi();
  }, [search, paginaActual]);

  // definir la página anterior
  const paginaAnterior = () => {
    const nuevaPaginaActual = paginaActual - 1;

    if (nuevaPaginaActual === 0) return;

    setPaginaActual(nuevaPaginaActual);
  };

  // definir la pagina siguiente
  const paginaSiguiente = () => {
    const nuevaPaginaActual = paginaActual + 1;

    if (nuevaPaginaActual > totalPaginas) return;

    setPaginaActual(nuevaPaginaActual);
  };

  return (
    <div className="container">
      <header className=" py-3" style={{ backgroundColor: "#e5e7eb" }}>
        <h1 className="text-center">
          <a
            href="https://www.lburbano.site"
            className="text-dark"
            style={{ textDecoration: "none" }}
          >
            Leandro Burbano
          </a>
        </h1>
      </header>
      <div className="jumbotron">
        <p className=" text-center h1 pb-4">Buscador de Imágenes</p>

        <Formulario setSearch={setSearch} />
      </div>
      <div className="row justify-content-center">
        <ListadoImagenes imagenes={imagenes} />
        {paginaActual === 1 ? null : (
          <button
            className="btn btn-info mr-1 d-flex align-items-center"
            type="button"
            onClick={paginaAnterior}
          >
            <TiArrowLeftThick />
            <span>Anterior</span>
          </button>
        )}
        {paginaActual === totalPaginas ? null : (
          <button
            className="btn btn-info d-flex align-items-center"
            type="button"
            onClick={paginaSiguiente}
          >
            <span>Siguiente</span>
            <TiArrowRightThick />
          </button>
        )}
      </div>
    </div>
  );
}

export default App;
